import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  HStack,
  Image,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";

import { partial } from "filesize";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import { RiAttachment2, RiDeleteBinLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { ITheoryQuestion } from "../../../../models/assignments/theory-assignment.model";
import trainerAssignmentService from "../../../../services/trainer/trainer-assignment.service";

export default function TrTheoryUpload() {
  const navigate = useNavigate();
  const toast = useToast();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [questionList, updateQuestionList] = useState<ITheoryQuestion[]>([]);
  const [filetype, setFiletype] = useState<string | undefined>("");
  const [batchFile, setbatchFile] = useState<File | undefined>();
  const [uploadFileSize, setUploadFileSize] = useState("");
  const [filename, setFilename] = useState("");
  const [show_form, setFormStatus] = useState(true);
  const [assignmentId, setAssignmentId] = useState("");
  const [ass_name, setAssname] = useState("");

  useEffect(() => {
    const question_header = localStorage.getItem("naptin_assignment");
    if (question_header) {
      setAssignmentId(JSON.parse(question_header).uuid);
      setAssname(JSON.parse(question_header).title);
    }
  }, []);

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};

      if (!values.question) {
        errors.question = "Question is required";
      }

      return errors;
    },
    initialValues: {
      image_file: "",
      question: "",
      description: "",
      sponsorName: "",
    },
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        if (batchFile !== undefined) {
          formData.append("file", batchFile);
          formData.append("file_type", "Image");
        }
        formData.append("question", values.question);
        formData.append("description", values.description);
        formData.append("total_mark", "2");
        //total_mark

        formData.append("uuid", assignmentId);

        const createQuestion =
          await trainerAssignmentService.createAssignmentQuestion(
            formData,
            assignmentId
          );
        if (createQuestion) {
          updateQuestionList([...questionList, createQuestion.data]);
          formik.resetForm();
          setbatchFile(undefined);
          setFormStatus(false);
          toast({
            title: "Question",
            description: "Question added successfully",
            status: "success",
          });
        }
      } catch (error: any) {
        toast({
          title: "Question",
          description: `${error.message}`,
          status: "error",
        });
      } finally {
        setFilename("");
        setFiletype("");
        setbatchFile(undefined);
        setUploadFileSize("");
      }
    },
  });
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value) {
      const fileName = e.target.files?.item(0)?.name as string;

      const fileType = e.target.files?.item(0)?.type;

      const file = e.target.files?.item(0) as File;

      const allowedFileTypes = ["image/png", "image/jpeg", "image/jpg"];

      if (!allowedFileTypes.includes(file.type)) {
        toast({
          title: "Invalid file type.",
          description: "You can only upload image files (png, jpg, jpeg).",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        // Reset file input
        e.target.value = "";
        setFilename("");
        setbatchFile(undefined);
        return;
      } else {
        setFilename(fileName);
        setFiletype(fileType);
        setbatchFile(file);
        const fileSize = partial({ base: 2, standard: "jedec" });
        setUploadFileSize(fileSize(file.size));
      }
    } else {
      setFilename("");
      setbatchFile(undefined);
    }

    formik.handleChange(e);
  };

  return (
    <Box minHeight="100vh" bg="#F9F8F8">
      <Box position="fixed" zIndex="1" width="100%">
        <Box>
          <Flex
            px={12}
            height="70px"
            bg="#FFFFFF"
            color="#616161"
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box mx={"auto"} my="auto">
              <Text
                pt="15px"
                color="#959595"
                fontWeight={"600"}
                bg="white"
                fontSize={"24px"}
                mr="20px"
                width="100%"
                textTransform={"capitalize"}
                height="70px"
              >
                {ass_name}
              </Text>
            </Box>
            <HStack spacing={6}>
              <Button
                pb="50px"
                px="30px"
                mt="30px"
                fontSize={16}
                variant="unstyled"
                onClick={() => {
                  navigate(-1);
                }}
                colorScheme="red"
                size="md"
              >
                Exit
              </Button>
            </HStack>
          </Flex>
        </Box>
      </Box>
      <Flex
        minHeight="100vh"
        width="100%"
        bg="white"
        justifyContent={"center"}
        marginBottom={"2rem"}
      >
        <Box width="80%" pt="25px" pl="40px" marginTop={"3.5rem"}>
          {questionList.length > 0 &&
            questionList.map((each, index) => (
              <Box
                p="25px"
                key={index}
                border="1px solid"
                borderColor="lightgray"
                mr="80px"
                borderRadius="7px"
                marginBottom={"1.2rem"}
              >
                <HStack spacing="5px" width="100%">
                  <Text>{index + 1}.</Text>
                  <Box width="100%">
                    <Text>{each.question}</Text>
                    <Text>{each.description}</Text>
                  </Box>
                </HStack>
                <Box
                  display={"flex"}
                  justifyContent="center"
                  width={"100%"}
                  mx="auto"
                >
                  {" "}
                  {each.file_url ? (
                    <Box width="70%" height={"120px"}>
                      <Image src={each.file_url} width="70%" height="120px" />
                    </Box>
                  ) : (
                    <Text></Text>
                  )}
                </Box>

                <Flex
                  borderTop="1px solid"
                  pt="10px"
                  mt="10px"
                  borderColor="lightgray"
                  justifyContent="flex-end"
                >
                  <HStack spacing="2px">
                    <RiDeleteBinLine />
                    <Text>Delete</Text>
                  </HStack>
                </Flex>
              </Box>
            ))}
          {show_form && (
            <form onSubmit={formik.handleSubmit}>
              <Box
                p="25px"
                border="1px solid"
                borderColor="lightgray"
                mr="80px"
                borderRadius="7px"
              >
                <HStack spacing="5px" width="100%">
                  <Box width="100%">
                    <Text>{questionList.length + 1}.</Text>
                    <FormControl
                      mb="26px"
                      isInvalid={
                        formik.errors.question && formik.touched.question
                          ? true
                          : false
                      }
                    >
                      <Input
                        width="100%"
                        color="#959595"
                        bg="white"
                        mb="5px"
                        mr="20px"
                        height="45px"
                        placeholder="Type the question here "
                        fontSize="14px"
                        value={formik.values.question}
                        name="question"
                        onChange={formik.handleChange}
                        variant="outline"
                        size="sm"
                      />
                      <FormErrorMessage fontSize={12}>
                        {formik.errors.question}
                      </FormErrorMessage>
                    </FormControl>
                    <Input
                      width="100%"
                      color="#959595"
                      bg="white"
                      mr="20px"
                      height="45px"
                      value={formik.values.description}
                      name="description"
                      onChange={formik.handleChange}
                      placeholder="Add further instruction(Optional) "
                      fontSize="14px"
                      variant="flushed"
                      size="sm"
                    />
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.description}
                    </FormErrorMessage>
                  </Box>
                </HStack>
                {filename && (
                  <Box>
                    <Table variant="unstyled">
                      <Thead fontWeight="semibold">
                        <Tr color="brand.subtitle" fontSize={14}>
                          <Td>Filename</Td>
                          <Td>Type</Td>

                          <Td>Size</Td>
                        </Tr>
                      </Thead>

                      <Tbody>
                        <Tr fontSize={13} color="brand.subtitle">
                          <Td maxW="20em">{filename}</Td>
                          <Td>{filetype}</Td>
                          <Td>{uploadFileSize}</Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </Box>
                )}
                <Flex
                  borderTop="1px solid"
                  pt="10px"
                  color={"#EC3337"}
                  borderColor="lightgray"
                  justifyContent="flex-end"
                >
                  <input
                    accept="image/*"
                    type="file"
                    name="image_file"
                    ref={inputRef}
                    onChange={(e) => handleFileChange(e)}
                    style={{ display: "none" }}
                  ></input>

                  <HStack
                    spacing="2px"
                    cursor={"pointer"}
                    onClick={() => inputRef?.current?.click()}
                  >
                    <RiAttachment2 />
                    <Text>Attach Image</Text>
                  </HStack>
                </Flex>

                <Flex
                  borderTop="1px solid"
                  pt="10px"
                  borderColor="lightgray"
                  justifyContent="center"
                >
                  <HStack as={"button"} type="submit" spacing="2px">
                    <BsCheckCircleFill color={"#EC3337"} />
                    <Text color={"#EC3337"}>Confirm</Text>
                  </HStack>
                </Flex>
              </Box>
            </form>
          )}
          <Flex justifyContent="center">
            <Button
              py="13px"
              px="30px"
              mt="30px"
              ml="20px"
              onClick={() => setFormStatus(true)}
              borderRadius="0px"
              fontSize={16}
              colorScheme="red"
              size="md"
            >
              ADD QUESTION
            </Button>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
}
